import React from "react";

/**
 * Catches render errors so the whole app does not white-screen.
 * Logs in development; production users see a friendly message + reload.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV === "development") {
      console.error("ErrorBoundary:", error, errorInfo);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: 24,
            fontFamily: "system-ui, sans-serif",
            background: "var(--theme-surface-muted-panel)",
            color: "#222",
            textAlign: "center",
          }}
        >
          <h1 style={{ fontSize: "1.25rem", marginBottom: 12 }}>Something went wrong</h1>
          <p style={{ maxWidth: 420, marginBottom: 24, lineHeight: 1.5 }}>
            The page hit an unexpected error. You can try reloading. If the problem continues, please
            contact support.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: "10px 20px",
              borderRadius: 999,
              border: "1px solid #ddd",
              background: "var(--theme-surface-white)",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Reload page
          </button>
          {process.env.NODE_ENV === "development" && this.state.error?.message ? (
            <pre
              style={{
                marginTop: 24,
                textAlign: "left",
                maxWidth: "90vw",
                overflow: "auto",
                fontSize: 12,
                color: "#c00",
              }}
            >
              {this.state.error.message}
            </pre>
          ) : null}
        </div>
      );
    }

    return this.props.children;
  }
}
